import mixitup from 'mixitup';
import debounce from 'lodash.debounce';
import mixitupMultifilter from '../vendor/mixitup-multifilter';

export default class TrainingFilter {
	constructor($trainingfilter) {
		this.filterContainer = $trainingfilter;
		this.cardsContainer = document.querySelector('[data-training-container]');
		this.checkedInputs = null;
		this.initialState = true;
		this.originalCollection = this.cardsContainer.querySelectorAll('.c-trainingcard');

		this.resetBtns = document.querySelectorAll('[data-reset-filter]');

		this.resetBtns.forEach((btn) => {
			btn.addEventListener('click', this.resetFilters.bind(this));
		});

		this.searchInput = this.filterContainer.querySelector('[data-search-training]');

		this.searchInput.addEventListener('keyup', debounce(this.filter.bind(this), 300));

		this.filterContainer.addEventListener('change', this.filter.bind(this));

		this.filterContainer.addEventListener('submit', (e) => {
			e.preventDefault();
			this.filter();
		});

		mixitup.use(mixitupMultifilter);

		this.mixer = mixitup(this.cardsContainer, {
			selectors: {
				target: '.c-trainingcard',
			},
			animation: {
				duration: 400,
				queueLimit: 5,
				effects: 'fade translateY(100px)',
			},
			multifilter: {
				enable: true,
			},

			load: {
				filter: 'none',
			},
		});

		this.filter(true);
	}

	resetFilters() {
		this.checkedInputs.forEach((checkedInput) => {
			checkedInput.checked = false;
		});

		this.searchInput.value = '';

		this.filter(true);
	}

	filter(interaction = true) {
		if (interaction) {
			this.initialState = false;
		}

		this.checkedInputs = this.filterContainer.querySelectorAll(':checked');

		let selector = '.c-trainingcard';

		// custom selector based on checked inputs
		if (this.checkedInputs.length) {
			selector = '';

			this.checkedInputs.forEach((input) => {
				selector += `.${input.value}`;
			});
		}

		// collection cards with the default selector or based on custom selector
		let collectionCards = this.cardsContainer.querySelectorAll(selector);

		// if there is a search input you add a new value to the collection
		if (this.searchInput.value && collectionCards) {
			collectionCards = Array.from(collectionCards).filter((card) => {
				const cardTitle = card.querySelector('.c-trainingcard__title');
				const title = this.normalizeString(cardTitle.textContent);
				const searchInput = this.normalizeString(this.searchInput.value);

				if (title.includes(searchInput)) {
					return true;
				}
			});
		}

		this.mixer.filter(collectionCards);

		let itemCount = collectionCards.length;
		let titleEl = document.getElementById('counter');
		this.failMessage = document.querySelector('[data-fail-message]');

		if (itemCount <= 0) {
			titleEl.innerHTML = '';
			this.failMessage.style.display = 'block';
		} else {
			titleEl.innerHTML = `(${itemCount})`;
			this.failMessage.style.display = 'none';
		}
	}

	normalizeString(str) {
		return str
			.toLowerCase()
			.replace(/[&\/\\#,+()$~%.'"’:*?<>{}]/g, '')
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '');
	}
}
